import { defineMessage } from 'react-intl';

export const STATSIG_EVENT_AUTO_CREATE_NEXT_EVENT =
    'Creator Home - Auto Create button Next Event - Click';

export const NEXT_EVENT_TITLE = defineMessage({
    id: 'Your next event',
    defaultMessage: 'Your next event',
});
export const CREATE_EVENT_HREF = '/manage/events/create';
export const AUTO_CREATE_EVENT_HREF = '/manage/events/auto-create';

export const CREATE_EVENT = defineMessage({ id: 'Create event', defaultMessage: 'Create event' });
export const CREATE_EVENT_WITH_AI = defineMessage({
    id: 'Create with AI',
    defaultMessage: 'Create with AI',
});
export const CREATE_NEW_EVENT = defineMessage({
    id: 'Start from scratch',
    defaultMessage: 'Start from scratch',
});
export const CREATE_NEW_EVENT_WITH_AI = defineMessage({
    id: 'Create my event faster with AI',
    defaultMessage: 'Create my event faster with AI',
});
export const CREATE_NEW_EVENT_SUBTITLE = defineMessage({
    id: 'Add all your event details, create new tickets, and set up recurring events',
    defaultMessage: 'Add all your event details, create new tickets, and set up recurring events',
});
export const CREATE_NEW_EVENT_WITH_AI_SUBTITLE = defineMessage({
    id: "Answer a few quick questions to generate an event that's ready to publish almost instantly",
    defaultMessage:
        "Answer a few quick questions to generate an event that's ready to publish almost instantly",
});
